import { safeInvoke } from './tauri-secure-storage-util'

import type { SecureStorageError } from '../secure-storage-error'
import type {
  PathfinderSignAndSendPayload,
  PathfinderSignAndSendResponse,
} from '../secure-storage-service'
import type { Result } from '@blade/std-lib'

export const singAndSendPathfinderSwapTransaction = async (
  payload: PathfinderSignAndSendPayload,
): Promise<
  Result.Result<PathfinderSignAndSendResponse, SecureStorageError>
> => {
  return safeInvoke<PathfinderSignAndSendResponse>(
    'sign_and_send_pathfinder_tx',
    { params: payload },
  )
}
